<script>
import AboutUsCardsSection from './AboutUsCardsSection'

export default AboutUsCardsSection.extend({
  computed: {
    sectionClass() {
      return `about-us-staff-section${this.sectionHighlightClasses}`
    }
  },

  methods: {
    getSectionNamespace() {
      return this.namespace
    },
  },
})
</script>

<style lang="less">
.about-us-staff-section {
  .about-us-section-wrapper {
    .about-us-section-content-wrapper {
      @apply flex flex-wrap;

      .about-us-section-content-card {
        @apply w-full mb-4 block;

        .about-us-section-content-card-image {
          @apply mb-4 w-full;
        }

        .about-us-section-content-card-body {
          @apply w-full;
        }

        .about-us-section-content-card-heading {
          @apply text-center text-lg;
        }

        .about-us-section-content-card-text {
          @apply text-center;
        }
      }
    }
  }
}

@screen md {
  .about-us-staff-section {
    .about-us-section-wrapper {
      .about-us-section-content-wrapper {
        .about-us-section-content-card {
          @apply w-1/2 px-2;
        }
      }
    }
  }
}

@screen lg {
  .about-us-section {
    &.about-us-staff-section {
      .about-us-section-wrapper {
        .about-us-section-content-wrapper {
          .about-us-section-content-card {
            @apply w-1/4 px-4;
          }
        }
      }
    }
  }
}
</style>
